import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex inner" }
const _hoisted_2 = {
  key: 0,
  class: "avatar"
}
const _hoisted_3 = { class: "message-wrapper flex-fill" }
const _hoisted_4 = { class: "message-content-wrapper" }
const _hoisted_5 = {
  class: /*@__PURE__*/_normalizeClass({'message-text': true})
}
const _hoisted_6 = { class: "edit-message-time message-color" }
const _hoisted_7 = { class: "edit-message-time message-color" }
const _hoisted_8 = { class: "message-color font-italic break-word" }
const _hoisted_9 = { class: "message-color font-italic break-word d-flex" }
const _hoisted_10 = { class: "pr-1" }
const _hoisted_11 = { class: "flex-fill text-truncate" }
const _hoisted_12 = {
  key: 1,
  class: "avatar"
}

import {computed, inject, ref, useSlots} from 'vue';
import Dictionary from "~/ts/library/Dictionary";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";
import CoreUiChatHistoryMessageTime from "~/core-ui/vue/chat/CoreUiChatHistoryMessageTime.vue";
import CoreUiHtmlify from "~/core-ui/vue/ui/CoreUiHtmlify.vue";
import OperatorApplicationPlatformInterface
    from "~/operatorApplication/ts/platform/OperatorApplicationPlatformInterface";
import CoreUiChatHistoryMessageTitle from "~/core-ui/vue/chat/CoreUiChatHistoryMessageTitle.vue";
import CoreUiChatHistoryMessageContent from "~/core-ui/vue/chat/CoreUiChatHistoryMessageContent.vue";
import CoreUiHtmlifySnippetEventInterface from "~/core-ui/vue/ui/CoreUiHtmlifySnippetEventInterface";
import CoreUiChatHistoryMessageExposeInterface from "~/core-ui/vue/chat/CoreUiChatHistoryMessageExposeInterface";
import {CoreUiChatHistoryActionsInterface} from "~/core-ui/vue/chat/CoreUiChatHistoryActions";
import {SHOW_MESSAGE_STATUS_INJECTION_KEY} from "~/core-ui/vue/chat/CoreUiChatHistoryExposeInterface";
import Tags from "~/cabinet/vue/interface/data/Tags.vue";
import {__} from "~/ts/library/Translate";
import CoreUiChatHistorySystemMessage from "~/core-ui/vue/chat/CoreUiChatHistorySystemMessage.vue";
import CoreUiChatHistoryMessageTimeValue from "~/core-ui/vue/chat/CoreUiChatHistoryMessageTimeValue.vue";
import ObjectHelper from "~/ts/library/ObjectHelper";
import CoreUiChatHistoryMessageReactionList from "~/core-ui/vue/chat/reaction/CoreUiChatHistoryMessageReactionList.vue";
import CoreUiChatHistoryMessageButton from "~/core-ui/vue/chat/CoreUiChatHistoryMessageButton.vue";
import DateHelper from "~/ts/library/Date";
import getOperatorDisplayName from "~/operatorApplication/ts/service/operators/getOperatorDisplayName";
import CoreUiChatHistoryMessageStatus from "~/core-ui/vue/chat/CoreUiChatHistoryMessageStatus.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {getOperatorByMessage} from "~/operatorApplication/ts/service/operators/getOperatorByMessage";
import CoreUiChatHistoryMessageAvatar from "~/core-ui/vue/chat/CoreUiChatHistoryMessageAvatar.vue";
import isShowLikeClientMessage from "~/operatorApplication/ts/service/operators/isShowLikeClientMessage";
import SizeObserverWrapper from "~/core-ui/vue/ui/SizeObserverWrapper.vue";


//Никаких зависимостей кабинета или приложения оператора!!! Универсальный компонент


const __default__ = {
    name: "CoreUiChatHistoryMessage"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {},
    operatorsDictionary: {},
    virtualOperatorsDictionary: {},
    previousMessage: {},
    nextMessage: {},
    shortMargin: { type: Boolean },
    you: {},
    client: {},
    dialog: {},
    messageTags: {},
    messageActions: {},
    showSeconds: { type: Boolean, default: true },
    clientMessageBackground: { default: "client-default" },
    operatorMessageBackground: { default: "blue" },
    selected: { type: Boolean },
    htmlify: {},
    operatorApplicationPlatform: {},
    showOperatorLogins: { type: Boolean, default: true },
    showOperatorGroup: { type: Boolean },
    utc: { type: Boolean, default: false },
    customOperatorStatusDictionary: {},
    showDialogInfo: { type: Boolean, default: true },
    hasBackgroundImage: { type: Boolean },
    shortMessageMargin: { type: Boolean },
    messageSourceType: {},
    showAnsweredNotInTimeMessages: { type: Boolean },
    disallowShortMeta: { type: Boolean }
  },
  emits: ["click", "height-change", "dialog-closed-click"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let metaWidth = ref(0);
let metaHeight = ref(0);
const slots = useSlots();

let isShortMeta = computed(() => {
    return !
        (props.message.tags?.length > 0
            ||
            props.disallowShortMeta
            ||
            props.message.reactions?.length > 0
            ||
            props.message.editHistory?.length > 0
            ||
            props.message.messageType
            ||
            props.message.content.attachments?.length > 0
            ||
            props.message.content.knowledgeBaseArticles?.length > 0
            ||
            !!props.message.content.sticker
            ||
            props.message.contacts.length > 0
            ||
            (!props.message.id && !props.message.content.text)
            ||
            !!answeredNotInTimeError.value
        );

});

let applyTranslationPatch = ref(true);

let messageForDisplay = computed(() => {
    let result = props.message;
    if (applyTranslationPatch.value && result.translatePatch) {
        result = ObjectHelper.jsonClone(result);
        result.translatePatch = null;
        let paths = ObjectHelper.getAllValuesWithPath(props.message.translatePatch, true);
        for (let item of paths) {
            ObjectHelper.setObjectValueByPath(result, item.path, item.value);
        }
    }
    return result;
});

let answeredNotInTimeError = computed(() => {
    if (props.showAnsweredNotInTimeMessages) {
        if (props.message.isAnsweredNotInTimeForThisOperator && operator.value) {
            return __("Оператор ответил не вовремя");
        } else if (props.message.isAnsweredNotInTimeForAllOperators) {
            return __("Операторы ответили не вовремя");
        }
    }
    return null;
})

let showMessageStatus = inject(SHOW_MESSAGE_STATUS_INJECTION_KEY, computed(() => true));

let editExpanded = ref(false);

let operator = computed(() => {
    return getOperatorByMessage(props.message, props.operatorsDictionary, props.virtualOperatorsDictionary);
});

let color = computed(() => {
    return showLikeClientMessage.value ? props.clientMessageBackground : props.operatorMessageBackground;
});

let avatarSize = computed(() => {
    return '30px';
});

let isSticker = computed(() => {
    return props.client && !props.client.integration && !!props.message.content.sticker?.url;
})

let isShowLikeSystemInfo = computed(() => {
    return props.message.isShowLikeSystemInfo;
});

let isShowInMessageBubble = computed(() => !isSticker.value && !isShowLikeSystemInfo.value);

let showLikeClientMessage = computed(() => {
    return isShowLikeClientMessage(props.message, props.client, props.you) && !isShowLikeSystemInfo.value;
});

let messageClass = computed(() => {
    return CoreUiChatHistoryHelper.getMessageClass(props.message);
});

function isSameSender(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    let result = false;
    if (message) {
        if (!message.isShowLikeSystemInfo && !props.message.isShowLikeSystemInfo) {
            result = props.message.operatorLogin === message.operatorLogin && props.message.isSendByClient === message.isSendByClient;
            if (result) {
                if (message.isSendByClient) {
                    if (!props.operatorsDictionary[props.message.operatorLogin]) {
                        result = JSON.stringify(message.recipients) == JSON.stringify(props.message.recipients);
                    }
                }
            }
        }
    }
    if (result) {
        result = message.senderOverride?.name === props.message.senderOverride?.name && message.senderOverride?.avatar === props.message.senderOverride?.avatar;
    }
    return result;
}

let sameSenderAsPrevious = computed(() => {
    return isSameSender(props.previousMessage);
});

let sameSenderAsNext = computed(() => {
    return isSameSender(props.nextMessage);
});

let lastMessageOf = computed(() => {
    return (!props.nextMessage || !sameSenderAsNext.value);
});

let isComment = computed(() => {
    return props.message.messageType?.isComment;
});

let isForward = computed(() => {
    return props.message.messageType?.isForward;
})

let isOperatorComment = computed(() => {
    return props.message.messageType?.isOperatorComment;
});

let isNotification = computed(() => {
    return props.message.messageType?.isNotification;
});

let isAutoForward = computed(() => {
    return props.message.messageType?.isAutoForward;
});

let mouseDown = ref(false);


function onMouseDown() {
    mouseDown.value = true;
}

function onMouseMove() {
    mouseDown.value = false;
}

function onMouseUp() {
    if (mouseDown.value) {
        mouseDown.value = false;
        if (!props.message.typing) {
            if (props.selected) {
                emits("click");
            }
        }
    }
}

let errors = computed<string[]>(() => {
    let result = [];
    if (props.message.error) {
        result.push(props.message.error);
    }
    /*
    if (props.message.isRemoved) {
        result.push(__("Удалено"));
    }
    */
    return result;
})

function onHeightChange() {
    emits("height-change");
}

let snippetUrls = ref<string[]>([]);

function onSnippet(payload: CoreUiHtmlifySnippetEventInterface) {
    if (payload.snippet.type === "image") {
        snippetUrls.value.push(payload.url);
    }
}

function getEditMessageTimestampText(item?: OperatorApplicationApi.OperatorApplicationMessageEditHistoryOpenApiModel) {
    let timestamp = props.message.dateTime;
    if (item) {
        timestamp = item.timestamp;
    }
    let result = (new DateHelper(timestamp, props.utc)).toLocaleDateTimeString(true);
    if (!item) {
        result += ', ' + __('оригинальное сообщение');
    } else if (item.operatorLogin) {
        let operator = props.operatorsDictionary[item.operatorLogin];
        if (operator) {
            result += `, ${getOperatorDisplayName(operator)}`;
        }
    }
    return result;
}

let bbcodeAllowed = computed(() => {
    return props.client ? CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(props.client) : false;
});

__expose<CoreUiChatHistoryMessageExposeInterface>({
    isDownloadAvailable: () => {
        return CoreUiChatHistoryHelper.getUrlListForDownload(props.message, snippetUrls.value).length > 0 ? !!props.messageActions.download : false
    },
    download: () => {
        props.messageActions?.download({
            message: props.message,
            snippetUrls: snippetUrls.value,
        });
    }
})

return (_ctx: any,_cache: any) => {
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            [`color-${_unref(color)}`]: true,
            'chat-history-message': true,
            [_unref(messageClass)]: true,
            client: _unref(showLikeClientMessage),
            operator: !_unref(showLikeClientMessage),
            [`color-forward color-forward-${__props.operatorMessageBackground}`]: _unref(isForward),
            [`color-comment color-comment-${__props.operatorMessageBackground}`]: _unref(isComment),
            [`color-operator-comment color-operator-comment-${__props.operatorMessageBackground}`]: _unref(isOperatorComment) || __props.operatorMessageBackground === 'operator-comment',
            [`color-notification color-notification-${__props.operatorMessageBackground}`]: _unref(isNotification),
            [`color-auto-forward  color-auto-forward-${__props.operatorMessageBackground}`]: _unref(isAutoForward),
            'last-message-of': _unref(lastMessageOf),
            error: !!__props.message.error,
            selected: __props.selected,
            typing: __props.message.typing,
            'short-margin': __props.shortMargin,
            'is-removed': __props.message.isRemoved,
            'is-bubble-message': !_unref(isShowLikeSystemInfo),
            'is-system-info': _unref(isShowLikeSystemInfo),
            'is-dialog-close': __props.message.messageType && __props.message.messageType.isDialogClose
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(showLikeClientMessage) && __props.client)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(CoreUiChatHistoryMessageAvatar, {
              message: __props.message,
              client: __props.client,
              "avatar-size": _unref(avatarSize),
              "custom-operator-status-dictionary": __props.customOperatorStatusDictionary,
              operator: _unref(operator),
              you: __props.you
            }, null, 8, ["message", "client", "avatar-size", "custom-operator-status-dictionary", "operator", "you"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass({
                        'message-background-container message-background message-content-color': _unref(isShowInMessageBubble),
                    }),
          onMousedown: _withModifiers(onMouseDown, ["left"]),
          onClick: _withModifiers(onMouseUp, ["left"]),
          onMousemove: onMouseMove
        }, [
          (_unref(isShowLikeSystemInfo))
            ? (_openBlock(), _createBlock(CoreUiChatHistorySystemMessage, {
                key: 0,
                message: __props.message,
                utc: __props.utc,
                "has-background-image": __props.hasBackgroundImage
              }, _createSlots({
                default: _withCtx(() => [
                  _createVNode(CoreUiChatHistoryMessageContent, {
                    message: _unref(messageForDisplay),
                    htmlify: __props.htmlify,
                    "operator-application-platform": __props.operatorApplicationPlatform,
                    "message-actions": __props.messageActions,
                    operator: _unref(operator),
                    "show-sender-and-icon-before-text": "",
                    "show-operator-logins": __props.showOperatorLogins,
                    bbcode: _unref(bbcodeAllowed),
                    class: "message-content",
                    onHeightChange: onHeightChange,
                    onSnippet: onSnippet
                  }, null, 8, ["message", "htmlify", "operator-application-platform", "message-actions", "operator", "show-operator-logins", "bbcode"])
                ]),
                _: 2
              }, [
                (!__props.shortMessageMargin)
                  ? {
                      name: "time",
                      fn: _withCtx(() => [
                        _createVNode(CoreUiChatHistoryMessageTimeValue, {
                          message: __props.message,
                          utc: __props.utc,
                          "show-seconds": __props.showSeconds
                        }, null, 8, ["message", "utc", "show-seconds"])
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["message", "utc", "has-background-image"]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass({
                            'message-content-and-meta-wrapper': true,
                            'with-short-meta': _unref(isShortMeta)
                        }),
                style: _normalizeStyle({
                            '--meta-width': `${_unref(metaWidth)}px`,
                            '--meta-height': `${_unref(metaHeight)}px`
                        })
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (!_unref(sameSenderAsPrevious))
                    ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageTitle, {
                        key: 0,
                        class: _normalizeClass({
                                'sticker-message-info': _unref(isSticker)
                            }),
                        client: __props.client,
                        operator: _unref(operator),
                        message: __props.message,
                        "operators-dictionary": __props.operatorsDictionary,
                        "show-operator-logins": __props.showOperatorLogins,
                        "show-operator-group": __props.showOperatorGroup,
                        you: __props.you
                      }, {
                        before: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "before-title")
                        ]),
                        after: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "after-title")
                        ]),
                        _: 3
                      }, 8, ["class", "client", "operator", "message", "operators-dictionary", "show-operator-logins", "show-operator-group", "you"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_5, [
                    (!__props.message.editHistory || !_unref(editExpanded))
                      ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageContent, {
                          key: 0,
                          message: _unref(messageForDisplay),
                          htmlify: __props.htmlify,
                          "operator-application-platform": __props.operatorApplicationPlatform,
                          "message-actions": __props.messageActions,
                          bbcode: _unref(bbcodeAllowed),
                          onHeightChange: onHeightChange,
                          onSnippet: onSnippet
                        }, null, 8, ["message", "htmlify", "operator-application-platform", "message-actions", "bbcode"]))
                      : (_unref(editExpanded))
                        ? (_openBlock(), _createBlock(_component_el_timeline, { key: 1 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.editHistory, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_timeline_item, { key: index }, {
                                  default: _withCtx(() => [
                                    _createVNode(CoreUiChatHistoryMessageContent, {
                                      message: item.previousMessage,
                                      htmlify: __props.htmlify,
                                      bbcode: _unref(bbcodeAllowed),
                                      "operator-application-platform": __props.operatorApplicationPlatform,
                                      onHeightChange: onHeightChange,
                                      onSnippet: onSnippet
                                    }, null, 8, ["message", "htmlify", "bbcode", "operator-application-platform"]),
                                    _createElementVNode("div", _hoisted_6, [
                                      (item.statusId)
                                        ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageStatus, {
                                            key: 0,
                                            "status-id": item.statusId
                                          }, null, 8, ["status-id"]))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" " + _toDisplayString(getEditMessageTimestampText(index == 0 ? null : __props.message.editHistory[index - 1])), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128)),
                              _createVNode(_component_el_timeline_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(CoreUiChatHistoryMessageContent, {
                                    message: _unref(messageForDisplay),
                                    htmlify: __props.htmlify,
                                    "operator-application-platform": __props.operatorApplicationPlatform,
                                    "message-actions": __props.messageActions,
                                    bbcode: _unref(bbcodeAllowed),
                                    onHeightChange: onHeightChange,
                                    onSnippet: onSnippet
                                  }, null, 8, ["message", "htmlify", "operator-application-platform", "message-actions", "bbcode"]),
                                  _createElementVNode("div", _hoisted_7, [
                                    (__props.message.statusId)
                                      ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageStatus, {
                                          key: 0,
                                          "status-id": __props.message.statusId
                                        }, null, 8, ["status-id"]))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(getEditMessageTimestampText(__props.message.editHistory[__props.message.editHistory.length - 1])), 1)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                    (__props.message.editHistory)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: _normalizeClass(_unref(editExpanded) ? null : 'mt-3')
                        }, [
                          _createVNode(CoreUiChatHistoryMessageButton, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(editExpanded) //@ts-ignore
 ? editExpanded.value = !_unref(editExpanded) : editExpanded = !_unref(editExpanded))),
                            icon: "rectangle-vertical-history",
                            "is-client": __props.message.isSendByClient
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(editExpanded) ? _unref(__)('Скрыть историю изменений') : _unref(__)('Показать историю изменений')), 1)
                            ]),
                            _: 1
                          }, 8, ["is-client"])
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _renderSlot(_ctx.$slots, "after-content", _normalizeProps(_guardReactiveProps({message: __props.message})))
                ]),
                _createVNode(SizeObserverWrapper, {
                  class: _normalizeClass({
                                'message-meta-wrapper': true,
                                'short': _unref(isShortMeta),
                                'sticker-message-info': _unref(isSticker)
                            }),
                  onWidth: _cache[2] || (_cache[2] = ($event: any) => (_isRef(metaWidth) //@ts-ignore
 ? metaWidth.value = $event : metaWidth = $event)),
                  onHeight: _cache[3] || (_cache[3] = ($event: any) => (_isRef(metaHeight) //@ts-ignore
 ? metaHeight.value = $event : metaHeight = $event))
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "message-meta-start", _normalizeProps(_guardReactiveProps({message: __props.message}))),
                    (__props.message.tags && __props.message.tags.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "clearfix" }, null, -1)),
                          _createVNode(Tags, {
                            tags: __props.message.tags,
                            "possible-tags": __props.messageTags,
                            class: "mt-1 text-right tags",
                            "with-border": ""
                          }, null, 8, ["tags", "possible-tags"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (!__props.message.typing)
                      ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageTime, {
                          key: 1,
                          class: "message-color time",
                          message: __props.message,
                          "show-seconds": __props.showSeconds,
                          "show-status": !_unref(showLikeClientMessage) && _unref(showMessageStatus),
                          utc: __props.utc,
                          "show-translate-toggle": !!__props.message.translatePatch,
                          "message-source-type": __props.messageSourceType,
                          "apply-translation-patch": _unref(applyTranslationPatch),
                          "onUpdate:applyTranslationPatch": _cache[1] || (_cache[1] = ($event: any) => (_isRef(applyTranslationPatch) ? (applyTranslationPatch).value = $event : applyTranslationPatch = $event))
                        }, null, 8, ["message", "show-seconds", "show-status", "utc", "show-translate-toggle", "message-source-type", "apply-translation-patch"]))
                      : _createCommentVNode("", true),
                    (__props.message.reactions?.length > 0)
                      ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageReactionList, {
                          key: 2,
                          class: "mt-1",
                          message: __props.message,
                          client: __props.client,
                          "operators-dictionary": __props.operatorsDictionary,
                          you: __props.you,
                          "message-actions": __props.messageActions
                        }, null, 8, ["message", "client", "operators-dictionary", "you", "message-actions"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 3
                }, 8, ["class"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (error, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: _normalizeClass({
                                'mt-2 container-with-short-meta-space': true,
                                'sticker-message-info': _unref(isSticker)
                            })
                  }, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(error), 1)
                  ], 2))
                }), 128)),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clearfix" }, null, -1)),
                (_unref(answeredNotInTimeError))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass({
                                'mt-2 container-with-short-meta-space': true,
                                'sticker-message-info': _unref(isSticker)
                            })
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(FontAwesomeIcon, {
                            icon: "hourglass-end",
                            class: "mr1"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(answeredNotInTimeError)), 1)
                      ])
                    ], 2))
                  : _createCommentVNode("", true)
              ], 6))
        ], 34)
      ]),
      (!_unref(showLikeClientMessage))
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (!__props.client?.type.isCrossOperatorsConversationChat)
              ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageAvatar, {
                  key: 0,
                  message: __props.message,
                  client: __props.client,
                  "avatar-size": _unref(avatarSize),
                  "custom-operator-status-dictionary": __props.customOperatorStatusDictionary,
                  operator: _unref(operator),
                  you: __props.you
                }, null, 8, ["message", "client", "avatar-size", "custom-operator-status-dictionary", "operator", "you"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})